import styled from "styled-components";
import { StyledGlobalMainContainer } from "../globalStyle";

export const StyledContainer = styled(StyledGlobalMainContainer)`
  padding-top: 73px;
  padding-bottom: 64px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 27px 22px;
    grid-row-gap: 29px;
  }
  @media (max-width: 425px) {
    grid-template-columns: 1fr;
    padding: 27px 22px;
    grid-row-gap: 29px;
  }
`;

export const StyledInnerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 992px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 40px;
    grid-column-gap: 20px;
  }
  @media (max-width: 375px) {
    grid-template-columns: 1fr;
    grid-column-gap: 20px;
  }
`;

export const StyledUl = styled.ul`
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  grid-row-gap: 20px;
`;

export const StyledLi = styled.li`
  font-size: 16px;
  color: #264445;
  font-weight: 500;
  cursor: pointer;

  a {
    text-decoration: none;
    color: inherit;
  }
`;

export const StyledRightReserved = styled.p`
  font-size: 16px;
  color: #264445;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  @media (max-width: 768px) {
    grid-row-start: 3;
    grid-column-start: 1;
    grid-column-end: 2;
  }
`;

export const StyledBottomContainer = styled.div`
  margin-top: 53px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

// export const StyledUl = styled.ul`
//   display: grid;
//   grid-auto-flow: column;
//   grid-column-gap: 30px;
//   @media (max-width: 768px) {
//     grid-auto-flow: column;
//     grid-column-gap: 15px;
//     justify-items: start;
//   }
//   @media (max-width: 425px) {
//     grid-auto-flow: column;
//     grid-column-gap: 15px;
//     justify-items: center;
//   }
// `;

// export const StyledLi = styled.li`
//   a {
//     text-decoration: none;
//     font-family: "tbc-Medium";
//     font-size: 14px;
//     font-weight: 500;
//     font-stretch: normal;
//     font-style: normal;
//     line-height: 1.14;
//     letter-spacing: normal;
//     color: #264445;
//     :hover {
//       color: #89C35C;
//     }
//   }
// `;

export const StyledSocialMediaContainer = styled.div`
  justify-self: end;
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-items: center;
  grid-column-gap: 55px;
  svg path {
    fill: #264445;
  }
  @media (max-width: 768px) {
    justify-self: end;
  }
  @media (max-width: 425px) {
    justify-self: center;
  }
`;

export const StyledListTitle = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: #264445;
`;
